// Same bar as TYPE_CONFIDENCE_MIN in backend/src/services/schoolEmailJudge.js.
const TYPE_CONFIDENCE_MIN = 0.75;

function formatSchoolWhen(value, { withTime = false, variant = 'full' } = {}) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const timeZone = 'America/Santiago';
  if (variant === 'medium') {
    return withTime
      ? date.toLocaleString('es-CL', { timeZone, dateStyle: 'medium', timeStyle: 'short' })
      : date.toLocaleDateString('es-CL', { timeZone, dateStyle: 'medium' });
  }
  if (variant === 'short') {
    return date.toLocaleDateString('es-CL', { timeZone, weekday: 'short', day: 'numeric', month: 'short' });
  }
  return withTime
    ? date.toLocaleString('es-CL', { timeZone, dateStyle: 'full', timeStyle: 'short' })
    : date.toLocaleDateString('es-CL', { timeZone, weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}

function typeIsUncertain(confidence) {
  return confidence != null && confidence !== '' && Number(confidence) < TYPE_CONFIDENCE_MIN;
}

// "Evento" only when the mail is already on the calendar. A date-only value
// (extracted_has_time false) does not print a clock: the stored noon UTC
// would show as 09:00 in Chile during summer.
function schoolWhenLabel(email, variant = 'full') {
  if (!email) return null;
  if (email.calendar_event_id && (email.calendar_start || email.extracted_date)) {
    const when = email.calendar_start || email.extracted_date;
    const withTime = email.calendar_start
      ? email.calendar_all_day !== true
      : email.extracted_has_time === true;
    return { kind: 'event', text: formatSchoolWhen(when, { withTime, variant }) };
  }
  if (email.extracted_date) {
    return {
      kind: 'date',
      text: formatSchoolWhen(email.extracted_date, {
        withTime: email.extracted_has_time === true,
        variant,
      }),
    };
  }
  return null;
}

module.exports = {
  TYPE_CONFIDENCE_MIN,
  formatSchoolWhen,
  typeIsUncertain,
  schoolWhenLabel,
};
